module.exports = __webpack_public_path__ + "img/YouPlusAnchorChallenger2020EN-9.29684261.jpg";